import {
  CurrentUser,
  IndieTabletopClubLogo,
  SessionInfo,
  SyncLog,
  useAppActions,
  useCurrentUser,
  useSessionInfo,
} from "@indietabletop/appkit";
import { Link } from "../link";
import { ViewContainer } from "../max-width-container";
import { MobileNavLayout } from "../mobile-nav-layout";
// import { useCurrentUser, useIsAuthError, useLogOut, useSessionInfo } from "../store/hooks";
import { useState } from "react";
import { fmt } from "../root-layout/fmt";
import * as common from "../utils.css";
import * as css from "./style.css";

function LoggedOutSection() {
  return (
    <section className={common.section}>
      <h2 className={common.heading}>Account</h2>

      <p className={common.paragraph}>
        Join Indie Tabletop Club or log into your account to enable army backup and sync.{" "}
        <Link href="/help/backup-and-sync" className={common.interactiveText}>
          Learn more
        </Link>
        .
      </p>

      <div className={css.actions}>
        <Link className={css.actionButton} style={common.primaryTheme} href="/join">
          Join
        </Link>

        <Link className={css.actionButton} href="~/login">
          Log in
        </Link>
      </div>
    </section>
  );
}

function PoweredByITC() {
  return (
    <div className={css.poweredBy.itcPowered}>
      <div>Powered by</div>
      <IndieTabletopClubLogo className={css.poweredBy.itcLogo} />
    </div>
  );
}

function AccountSection(props: { currentUser: CurrentUser; sessionInfo: SessionInfo | null }) {
  const { currentUser, sessionInfo } = props;
  const { logout } = useAppActions();
  const isMigrated = currentUser.email === "";

  return (
    <section className={common.section}>
      <h2 className={common.heading}>Account</h2>
      {isMigrated ?
        <p className={common.paragraph}>Logged in as: N/A (session expired)</p>
      : <p className={common.paragraph}>
          {`Logged in as: ${currentUser.email}`}
          {sessionInfo && (
            <>
              <br />
              {`Session started: ${fmt.date(sessionInfo.createdTs)}`}
              <br />
              {`Expires: ${fmt.date(sessionInfo.expiresTs)}`}
            </>
          )}
          <br />
          {`Status: ${props.currentUser.isVerified ? "Verified" : "Not verified"}`}
        </p>
      }

      <p className={common.paragraph}>
        <button className={common.interactiveText} onClick={logout}>
          Log out
        </button>
      </p>

      <PoweredByITC />
    </section>
  );
}

function SyncLogSection() {
  const currentUser = useCurrentUser();

  if (!currentUser?.isVerified) {
    return (
      <section className={common.section}>
        <h2 className={common.heading}>Sync log</h2>
        <p className={common.paragraph}>
          Backup and sync disabled. Please verify your account to enable backup and sync.
        </p>
      </section>
    );
  }

  return (
    <section className={common.section}>
      <h2 className={common.heading}>Sync log</h2>

      <SyncLog />
    </section>
  );
}

export function AccountPageMain() {
  const currentUser = useCurrentUser();
  const sessionInfo = useSessionInfo();
  const [now] = useState(() => Date.now());
  const isExpired = !!sessionInfo?.expiresTs && sessionInfo.expiresTs < now;

  if (!currentUser) {
    return <LoggedOutSection />;
  }

  return (
    <>
      {isExpired && (
        <section className={common.section}>
          <h2 className={common.heading}>Your session has expired</h2>
          <p className={common.paragraph}>
            {"This is most likely because you have not used the app in a while. "}
            <Link href="~/login" className={common.interactiveText}>
              Log in again
            </Link>
            {" to resume syncing."}
          </p>
        </section>
      )}

      <AccountSection currentUser={currentUser} sessionInfo={sessionInfo} />

      <SyncLogSection />
    </>
  );
}

export function AccountPage() {
  return (
    <MobileNavLayout title="Account">
      <ViewContainer maxWidth={false} padding="small">
        <AccountPageMain />
      </ViewContainer>
    </MobileNavLayout>
  );
}
